import { render, staticRenderFns } from "./CenterCard.vue?vue&type=template&id=b7c42c1e&scoped=true&"
import script from "./CenterCard.vue?vue&type=script&lang=js&"
export * from "./CenterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c42c1e",
  null
  
)

export default component.exports